<template>
    <div class="contents-finder">
        <div class="contents-finder__header-wrapper">
            <div class="contents-finder__title">
                <span>{{ $t('words.contents') }}</span>
            </div>
            <div class="search-input">
                <form class="pull-right" @submit.prevent="handleSearch">
                    <label class="sr-only" for="keyword">{{ $t('words.search') }}</label>
                    <input id="keyword" v-model="searchKeyword" :placeholder="$t('words.contents_name_search')"
                           class="form-control form__search" type="text">
                </form>
            </div>
            <div class="search-filter">
                <div class="form-checkbox">
                    <input id="only_selectable_check" :checked="onlySelectable"
                           type="checkbox"
                           @input="handleSuccessUploadFilterChecked">
                    <label for="only_selectable_check"></label>
                    <span :class="['channel-label']">
                        {{ $t('words.only_upload_success_contents_comments') }}
                </span>
                </div>
            </div>
        </div>
        <PerfectScrollbar v-show="mediaContents.data.length > 0" style="width:100%;height:100%">
            <div ref="dragContainer" :class="{
                'finder-list-container': true,
                'dayGridMonth': isDayGridMonth
            }">

                <ContentsFinderListItem
                    v-for="(mediaContent,index) in mediaContents.data"
                    :key="`mediaContent_${mediaContent.id}_${index}`"
                    :index="index"
                    :media-content="mediaContent"
                />

            </div>
        </PerfectScrollbar>

        <div v-if="mediaContents.data.length === 0 && mediaContents.load" :class="{
                'finder-list-container': true,
                'no-contents': true,
                'dayGridMonth': isDayGridMonth
            }">
            <span>{{ $t('paragraphs.no_contents_list') }}</span>
        </div>

        <div v-if="mediaContents.data.length > 0" class="finder-list-pagination">
            <ul arititle.channel.hidden_lista-label="navigation" class="pagination">
                <li :class="{
                    'pagination__item': true,
                     disabled: !mediaContents.links.prev
                }">
                    <button
                        aria-label="Previous"
                        class="pagination__link"
                        @click="loadMediaContents(mediaContents.links.prev)"
                    >
                        <i aria-hidden="true" class="icon icon-arrow-left-sm"/>
                        <span class="sr-only">{{ $t('pagination.previous') }}</span>
                    </button>
                </li>
                <li class="pagination__info-center">
                    {{ mediaContents.meta.current_page }} / {{ mediaContents.meta.last_page }}
                </li>
                <li :class="{
                    'pagination__item': true,
                    disabled: !mediaContents.links.next
                }">
                    <button
                        aria-label="Next"
                        class="pagination__link"
                        @click="loadMediaContents(mediaContents.links.next)"
                    >
                        <i aria-hidden="true" class="icon icon-arrow-right-sm"/>
                        <span class="sr-only">{{ $t('pagination.next') }}</span>
                    </button>
                </li>
            </ul>
        </div>
        <PreviewModal/>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ContentsFinderListItem from '@/components/cms/common/Schedule/SideBar/ContentsFinderListItem';
import MediaContentsProgressMixin from '@/components/mixin/MediaContentsProgressMixin';
import CalendarDragSettingMixin from '@/components/mixin/CalendarDragSettingMixin';
import PreviewModal from '@/components/cms/program/Modal/PreviewModal';

export default {
    name: 'ContentsFinder',

    components: {
        ContentsFinderListItem,
        PreviewModal,
    },

    mixins: [
        MediaContentsProgressMixin,
        CalendarDragSettingMixin,
    ],

    computed: {
        ...mapGetters('media_contents', ['mediaContents', 'onlySelectable']),
        ...mapGetters('calendar', ['calendarDefaultView']),
        total() {
            // pagination total
            return this.mediaContents.meta.total ? this.mediaContents.meta.total : 0;
        },
        from() {
            // pagination from
            return ((this.mediaContents.meta.current_page - 1) * this.mediaContents.meta.per_page) + 1;
        },
        to() {
            // pagination to
            if (this.mediaContents.meta.current_page === this.mediaContents.meta.last_page) {
                return this.mediaContents.meta.total;
            }
            return this.mediaContents.meta.per_page * this.mediaContents.meta.current_page;
        },
    },

    watch: {
        calendarDefaultView: {
            immediate: true,
            handler(val) {
                this.isDayGridMonth = val === 'dayGridMonth';
            },
        },
    },

    mounted() {
        this.init();
        $('#previewModal').on('hidden.bs.modal', () => {
            this.clearPreview();
        });
    },

    data() {
        return {
            searchKeyword: '',
            isDayGridMonth: false,
        };
    },
    methods: {
        ...mapMutations({
            setOnlySelectable: 'media_contents/setOnlySelectable',
            setFilter: 'media_contents/setFilter',
            setKeyword: 'media_contents/setKeyword',
            clearMediaContents: 'media_contents/clearMediaContents',
            clearPreview: 'preview/clearPreview',
        }),
        ...mapActions({
            doSearch: 'media_contents/doSearch',
            loadMediaContents: 'media_contents/loadMediaContents',
        }),
        init() {
            this.clearMediaContents();
            this.setOnlySelectable(false);
            this.doSearch();
        },
        handleSearch() {
            this.setKeyword(this.searchKeyword);
            this.doSearch();
        },
        handleSuccessUploadFilterChecked() {
            this.setOnlySelectable(!this.onlySelectable);
            this.doSearch();
        },
    },

    beforeDestroy() {
        this.clearMediaContents();
        $('#previewModal').hide();
    },
};
</script>
